import React from 'react';
import { SECRET_TAP } from '../../lib/rcu/catalog/security';

/**
 * Rapid-tap detector for the hidden console entrance.
 *
 * Counts taps inside a rolling window; once `SECRET_TAP.REQUIRED_TAPS` land
 * within `SECRET_TAP.WINDOW_MS` the callback fires and the count resets.
 */
export const useSecretTap = (onTriggered: () => void): (() => void) => {
  const tapsRef = React.useRef<number[]>([]);
  const triggeredRef = React.useRef(onTriggered);

  React.useEffect(() => {
    triggeredRef.current = onTriggered;
  }, [onTriggered]);

  return React.useCallback(() => {
    const now = Date.now();
    const recent = [...tapsRef.current, now].filter(
      (at) => now - at <= SECRET_TAP.WINDOW_MS,
    );

    if (recent.length >= SECRET_TAP.REQUIRED_TAPS) {
      tapsRef.current = [];
      triggeredRef.current();
      return;
    }
    tapsRef.current = recent;
  }, []);
};

export default useSecretTap;
